import api from './api';

// Best-effort browser geolocation. Resolves to {lat, lon, accuracy} or null
// if the user denied, the browser lacks the API, or the request times out.
// We never block clock-in on this — payroll shouldn't get stuck on a
// permission dialog.
export const getBrowserCoords = () => {
  if (typeof navigator === 'undefined' || !navigator.geolocation) {
    return Promise.resolve(null);
  }
  return new Promise((resolve) => {
    let done = false;
    const finish = (value) => {
      if (done) return;
      done = true;
      resolve(value);
    };
    const timeoutId = setTimeout(() => finish(null), 12000);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        clearTimeout(timeoutId);
        finish({
          lat: pos.coords.latitude,
          lon: pos.coords.longitude,
          accuracy: pos.coords.accuracy,
        });
      },
      () => {
        clearTimeout(timeoutId);
        finish(null);
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 },
    );
  });
};

export const clockIn = async (data = {}) => {
  const res = await api.post('/time-entries/clock-in', data);
  return res.data;
};

export const clockOut = async (entryId, data = {}) => {
  const res = await api.post(`/time-entries/${entryId}/clock-out`, data);
  return res.data;
};

export const getActiveEntry = async () => {
  const res = await api.get('/time-entries/active');
  return res.data;
};

export const listTimeEntries = async (params = {}) => {
  const res = await api.get('/time-entries', { params });
  return res.data;
};

export const createTimeEntry = async (data) => {
  const res = await api.post('/time-entries', data);
  return res.data;
};

export const updateTimeEntry = async (id, data) => {
  const res = await api.put(`/time-entries/${id}`, data);
  return res.data;
};

export const deleteTimeEntry = async (id) => {
  const res = await api.delete(`/time-entries/${id}`);
  return res.data;
};

export const getTimesheet = async (week) => {
  const res = await api.get('/time-entries/timesheet', { params: week ? { week } : {} });
  return res.data;
};
